const BookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 20 20" width="16">
    <path d="M16 8.3V0H3C1.3 0 0 1.3 0 3v12c0 1.7 1.3 3 3 3h6.5c1.1 1.2 2.7 2 4.5 2 3.3 0 6-2.7 6-6 0-2.6-1.7-4.8-4-5.7zM2 15V3c0-.6.4-1 1-1h1v14H3c-.6 0-1-.4-1-1zm4 1V2h8v6c-3.3 0-6 2.7-6 6 0 .7.1 1.4.4 2zm8 2c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" />
    <path d="M15 11h-2v2h-2v2h2v2h2v-2h2v-2h-2z" />
  </svg>
);

export default BookIcon;
